// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LQWV","type":"styles_type__33QYi","choices":"styles_choices__I1USD"};